import util   from '../../common/AppUtil';

const ServerMode = 1;
const ApiCode = "XStat";

export default {
  getListPage: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"list");
  },
  getSanityPage: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"sanity");
  },
  /*
  removeRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"del");
  },

  addRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"add");
  },

  saveRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"save");
  },

  getRecord: function(params) {
    return util.callServerPost(ServerMode,ApiCode,params,"get");
  }
  */
}
  


// WEBPACK FOOTER //
// ./src/api/bas/xstat.js